<template>
  <AdminCrudPage
    collection-name="services"
    title="Services"
    singular-title="Service"
    :fields="fields"
    :columns="columns"
    :seed-data="seedData"
  />
</template>

<script>
import AdminCrudPage from './AdminCrudPage.vue'

const DEFAULT_ICON = 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z'

export default {
  name: 'AdminServices',
  components: { AdminCrudPage },
  data() {
    return {
      columns: [
        { key: 'title', label: 'Title' },
        { key: 'badge', label: 'Badge' },
        { key: 'link', label: 'Links To' }
      ],
      fields: [
        { key: 'title', label: 'Title', type: 'text', required: true },
        { key: 'badge', label: 'Badge (short label, e.g. "Hotel")', type: 'text' },
        { key: 'description', label: 'Description', type: 'textarea' },
        { key: 'cta', label: 'Button Text (e.g. "View Hotel Inventory")', type: 'text' },
        { key: 'link', label: 'Links To (e.g. /hotels, /flights, /contact)', type: 'text' },
        { key: 'icon', label: 'Icon (advanced: SVG path data — leave default if unsure)', type: 'text', default: DEFAULT_ICON }
      ],
      seedData: [
        {
          title: 'Hotel Only Booking',
          badge: 'Hotel',
          description: 'Premium Makkah & Madina rooms adjacent to Haram with breakfast add-ons and early check-in support.',
          cta: 'View Hotel Inventory',
          link: '/hotels',
          icon: 'M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25'
        },
        {
          title: 'Flights & Visa Desk',
          badge: 'Flights',
          description: 'Any-country departures with low fares, coordinated with fast-track Umrah visa processing.',
          cta: 'Get Flight Deals',
          link: '/flights',
          icon: 'M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.874L5.999 12zm0 0h7.5'
        },
        {
          title: 'Private Transport',
          badge: 'Transport',
          description: 'Chauffeur-driven luxury vans for Jeddah airport transfers, Ziyarat tours, and intercity trips.',
          cta: 'Reserve Transport',
          link: '/contact',
          icon: 'M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12'
        },
        {
          title: 'Visa Assistance',
          badge: 'Visa',
          description: 'Dedicated case officers handle biometrics, documentation, and updates for Umrah visas worldwide.',
          cta: 'Start Visa Process',
          link: '/contact',
          icon: 'M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
        }
      ]
    }
  }
}
</script>
